import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTransferArrowRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 9,
	height: 13,
	viewBox: "0 0 9 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1 2.18996L1 10.81C1 11.667 2.00736 12.127 2.65493 11.5657L7.62805 7.25569C8.08814 6.85694 8.08814 6.14306 7.62805 5.74431L2.65493 1.43427C2.00736 0.873047 0.999999 1.33304 1 2.18996Z",
		fill: "#0050FF"
	})
});
export default SvgTransferArrowRight;
